<form [formGroup]="fieldForm" (ngSubmit)="addField()">
    <div style="display: flex; flex-direction: column;">
        <div style="flex: 1;">
            <mat-label style="font-weight: bold; font-size: medium;">{{ 'ADD-FIELD-DIALOG.FIELD-NAME' | translate }}</mat-label>
            <br />
            <mat-form-field style="width: 100%; margin-top: 10px; " appearance="outline">
                <input [(ngModel)]="fieldName" matInput type="text" placeholder="Field name" formControlName="name"
                    required />
                <mat-error *ngFor="let validation of field_validation_messages.name">
                    <mat-error class="error-message" *ngIf="fieldForm.get('name').hasError(validation.type) && 
                        (fieldForm.get('name').dirty || fieldForm.get('name').touched)">
                        {{validation.message}}
                    </mat-error>
                </mat-error>
            </mat-form-field>
            <br />
        </div>
        <div style="flex: 1; display: flex; flex-direction: row; justify-content: space-around; align-items: center; margin-top: 15px;">
            <button mat-flat-button style="width: 40%;" (click)="cancel()" type="button" class="cancel-field-add-btn">{{ 'ADD-FARM-DIALOG.CANCEL' |
                translate }}</button>
            <button mat-flat-button style="width: 40%;"  type="submit" [disabled]="!fieldForm.valid" class="buttons add-btn">
                {{ 'ADD-FARM-DIALOG.ADD-FARM' |
                translate }}</button>
        </div>
    </div>
</form>
